import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Step3ProductTable = ({ selectedConfig, onBack, onNext }) => {
  const [products, setProducts] = useState([]);
  const [variantList, setVariantList] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedVariantObj, setSelectedVariantObj] = useState(null);
  const [variantThumbnails, setVariantThumbnails] = useState({});

  const apiBase = 'https://hb.g-b.in/wp-json/wp/v2';

  useEffect(() => {
    const fetchVariants = async () => {
      const res = await fetch(`${apiBase}/variant?per_page=100&_embed`);
      const data = await res.json();
      setVariantList(data);

      const configVariantId = selectedConfig?.variant?.[0];
      let defaultVariantId = configVariantId || (data.length > 0 ? data[0].id : null);
      setSelectedVariant(defaultVariantId);
      setSelectedVariantObj(data.find(v => v.id === defaultVariantId));

      const thumbs = {};
      data.forEach(variant => {
        const style = variant.tax_style?.name || 'Uncategorized';
        if (!thumbs[style]) thumbs[style] = [];
        thumbs[style].push({
          id: variant.id,
          name: variant.name,
          thumbnail: variant.variant_thumbnail || 'https://via.placeholder.com/120x120?text=No+Thumb'
        });
      });
      setVariantThumbnails(thumbs);
    };

    fetchVariants();
  }, [selectedConfig]);

  useEffect(() => {
    const fetchProducts = async () => {
      if (!selectedConfig || !selectedVariant || variantList.length === 0) return;

      const configProducts = selectedConfig?.acf?.products || [];
      const selectedVariantData = variantList.find(v => v.id === selectedVariant);
      setSelectedVariantObj(selectedVariantData);

      const fetchedProducts = await Promise.all(
        configProducts.map(async ({ product }) => {
          const res = await fetch(`${apiBase}/product/${product}?_embed`);
          const originalData = await res.json();

          const originalTitle = originalData.title.rendered;
          const baseModel = originalTitle.split('-')[0];
          const selectedVariantSlug = selectedVariantData?.slug?.toUpperCase();
          const newSlug = `${baseModel}-${selectedVariantSlug}`;

          const altRes = await fetch(`${apiBase}/product?slug=${newSlug}&_embed`);
          const altData = await altRes.json();

          return altData?.[0] || originalData;
        })
      );

      setProducts(fetchedProducts);
    };

    fetchProducts();
  }, [selectedConfig, selectedVariant, variantList]);

  const getImage = (product) => {
    const media = product._embedded?.['wp:featuredmedia']?.[0];
    return (
      media?.media_details?.sizes?.large?.source_url ||
      media?.media_details?.sizes?.full?.source_url ||
      media?.source_url || ''
    );
  };

  return (
    <div className="pb-5">



            <h2 className="card-title mb-4 text-center">Step 3: Product Preview & Variant Switcher</h2>


            {products.length > 0 && (
              <div className="fixed-footer">
              
                <div className="d-flex justify-center">
                  <div className="mr-1 text-center">
                    <button className="button back" onClick={onBack}>← Back</button>
                  </div>
                  <div className="ml-1 text-center">
                    <button
                      className="button next"
                      onClick={() => onNext(products, selectedVariantObj)}
                    >
                      Next →
                    </button>
                  </div>
                
              </div>
              </div>
            )}


            {products.length === 0 ? (
              <div className="alert alert-warning text-center">No products found for selected variant.</div>
            ) : (
              <div id="product-display">
                {products.map((product, index) => (
                  <div className="product-thumbnail" key={`${product.id}-${selectedVariant}-${index}`}>
                    
                      <img
                        src={getImage(product)}
                        alt={product.title.rendered}
                        className=""
                        
                      />
                      
                        
                        <ul className="list-unstyled small mt-2">
                          <li><strong>Model:</strong> {product.title.rendered}</li>
                          <li><strong>Style:</strong> {
                            product._embedded?.['wp:term']?.flat().find(term => term.taxonomy === 'style')?.name || 'N/A'
                          }</li>
                          <li><strong>Type:</strong> {
                            product._embedded?.['wp:term']?.flat().find(term => term.taxonomy === 'type')?.name || 'N/A'
                          }</li>
                          <li><strong>Width:</strong> {
                            product._embedded?.['wp:term']?.flat().find(term => term.taxonomy === 'width')?.name || 'N/A'
                          }</li>
                        </ul>
                      </div>
                    
                  
                ))}
              </div>
            )}

              <h5 className="mb-3 mt-4 text-center">Choose a Variant:</h5>
                        <div class="variant-switcher">
              {Object.entries(variantThumbnails).map(([styleName, variants]) => (
                <div key={styleName} className="variant-style-group">
                  <h4 className="fw-bold mb-3">{styleName} Collection</h4>
                  <div
                    className="variant-thumbs"
                    style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}
                  >
                    {variants.map(variant => (
                      <div className="variant-btn" key={variant.id}>
                        <label
                          className={`text-center ${selectedVariant === variant.id ? 'is-active' : 'border-1'}`}
                          style={{ cursor: 'pointer' }}
                        >
                          <input
                            type="radio"
                            name="variant"
                            value={variant.id}
                            checked={selectedVariant === variant.id}
                            onChange={() => setSelectedVariant(variant.id)}
                            hidden
                          />
                          <img
                            src={variant.thumbnail}
                            alt={variant.name}
                            className=""

                          />
                          <p>{variant.name}</p>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>


          </div>

  );
};

export default Step3ProductTable;
